import axios from "axios";
export const loadSubscription = async username => {
  try {
    let subInfo = await axios.get("https://api.revenuecat.com/v1/subscribers/" + username, {
      headers: {
        "Content-Type": "application/json",
        "X-Platform": "stripe",
        Authorization: "Bearer " + "fLkKNTpXgmWNIbYnyPNkTBalyHBMXjJH"
      }
    });
    let subResult = await checkSubscription(subInfo);
    return subResult;
  } catch (error) {
    console.log("subscription load error");
    console.log(error.response);
  }
};
const checkSubscription = subInfo => {
  if (Object.entries(subInfo.data.subscriber.entitlements).length === 0) {
    return false;
  } else if (subInfo.data.request_date >= subInfo.data.subscriber.entitlements.basic.expires_date) {
    return false;
  } else {
    return true;
  }
};